import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss']
})
export class IntegrationsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
